import React from "react";
import { CleanAndSafeIcon } from "../../Icons/CleanAndSafeIcon";
import { IsAssociateIcon } from "../../Icons/IsAssociateIcon";
import { SustainabilityIcon } from "../../Icons/SustainabilityIcon";
import "./StoreCardIcons.css";

const iconSize = { width: 60, height: 60 };

function StoreCardIcons({ store }) {
  return (
    <div className="ahp-store-icons" style={{ height: iconSize.height }}>
      <>
        {store?.is_associate && (
          <IsAssociateIcon
            iconSize={iconSize}
            // leftMargin={70 * i}
          />
        )}
        {store?.ods && Object.keys(store?.ods).length && (
          <SustainabilityIcon
            iconSize={iconSize}
            sustainability={store.ods}
            // leftMargin={70 * i}
          />
        )}
        {store?.clean_and_safe && (
          <CleanAndSafeIcon
            iconSize={iconSize}
            // leftMargin={70 * i}
          />
        )}
      </>
    </div>
  );
}

export default StoreCardIcons;
